import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProfileSyncService } from '../../../services/profile-sync.service';
import { TransactionFailedRecord } from '../../../model/Transaction';
import { EventEmitterWithObservable } from '../../../../shared/EventEmitterWithValueReturned';

@Component({
    selector: 're-profile-sync-failed-users',
    templateUrl: './profile-sync-failed-users.component.html',
    styleUrls: ['./profile-sync-failed-users.component.scss'],
    standalone: false
})
export class ProfileSyncFailedUsersComponent implements OnInit {

  constructor(private profileSyncService:ProfileSyncService, private route: ActivatedRoute) { }


  failedUsers: TransactionFailedRecord[];

  load($event: EventEmitterWithObservable) {
    $event.ReturnValue = this.profileSyncService.getFailedUsers(+this.route.snapshot.params.processId);
  }
  ngOnInit(): void {
  }

}
